import { config } from "core/config/app";
import Main from "./pages/MainPage";
import OnboardingPage from "./pages/OnboardingPage";

const router = [
  {
    name: "MAIN",
    exact: true,
    path: `${config?.basename}/`,
    element: <Main />,
    title: "Main",
  },
  {
    name: "ONBOARDING",
    exact: true,
    path: `${config?.basename}/onBoarding`,
    element: <OnboardingPage />,
    title: "OnBoarding",
  },
];
export default router;
